import React, { useEffect, useState } from "react";
import { sectionPaddings } from "../../../TemplateConfig";
import tinycolor from "tinycolor2";
import "./SectionItemWrapper.css";
function SectionItemWrapper(props) {
  const { styles, layout } = props;
  const [focusClassName, setFocusClassName] = useState("sectionFocusStyle");
  const [sectionPading, setSectionPadding] = useState("unset");
  const [bgColor, setBgColor] = useState("#ffffff");

  useEffect(() => {
    if (props && props.SectionMargin) {
      const secMargin = parseInt(props && props.SectionMargin);
      setSectionPadding(sectionPaddings[secMargin - 1]);
    }
  }, [props && props.SectionMargin]);

  useEffect(() => {
    // if (
    //   styles &&
    //   styles.selectedBgColor &&
    //   styles.selectedBgColor.is_different_color &&
    //   layout == "rsbar"
    // ) {
    //   setFocusClassName("sectionDifferentFocusStyle");
    // }
    const { bgColor } = { ...styles };
    if (bgColor && bgColor.bgFill === "right" && props.layout == "rsbar") {
      setBgColor(
        tinycolor(bgColor && bgColor.bgColor).isLight() ? "#fff" : "#ffffff1f"
      );
    } else if (
      bgColor &&
      bgColor.bgFill === "left" &&
      props.layout == "lsbar"
    ) {
      setBgColor(
        tinycolor(bgColor && bgColor.bgColor).isLight() ? "#fff" : "#ffffff1f"
      );
    } else {
      setBgColor("#ffffff");
    }
  }, [styles, props]);

  return (
    <div
      className={`resume-item ${props.sectionId}-item  ${
        props.newSectionFocus == props.sectionId &&
        props.currentStateFocus == "item" &&
        props.newItemFocus &&
        props.newItemFocus == props.index.toString()
          ? focusClassName
          : ""
      }`}
      style={{
        paddingBottom: props.isFixedPaddingBottom ? props.paddingBottom : "0px",
        ...props.style,
        ...(props.newSectionFocus == props.sectionId &&
        props.currentStateFocus == "item" &&
        props.newItemFocus &&
        props.newItemFocus == props.index.toString()
          ? { backgroundColor: bgColor }
          : {}),
      }}
      id={`${props.sectionId}-${props?.index}`}
      onMouseDown={props.onMouseDown ? props.onMouseDown : ""}
      onClick={props.onClick ? props.onClick : ""}
    >
      {props.children}
    </div>
  );
}

export default SectionItemWrapper;
